import React from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { FaTwitter, FaFacebookF, FaLinkedinIn } from "react-icons/fa";

import styles from "./ShareButtons.module.css";

export default function ShareButtons({ url, ...rest }) {
  return (
    <div className={styles.container}>
      <TwitterShareButton className={styles.button} url={url}>
        <FaTwitter className={styles.icon} {...rest} />
      </TwitterShareButton>
      <LinkedinShareButton className={styles.button} url={url}>
        <FaLinkedinIn className={styles.icon} {...rest} />
      </LinkedinShareButton>
      <FacebookShareButton className={styles.button} url={url}>
        <FaFacebookF className={styles.icon} {...rest} />
      </FacebookShareButton>
    </div>
  );
}
